import { Bell } from "lucide-react";

const FeaturedAppPreview = () => (
  <div className="w-full aspect-video flex flex-col items-center justify-center gap-3 p-4 bg-feature-notifications/10">
    <div className="w-12 h-12 rounded-xl bg-feature-notifications/15 flex items-center justify-center">
      <Bell className="w-6 h-6 text-feature-notifications" aria-hidden="true" />
    </div>
    <p className="text-sm font-medium text-foreground">Notifications</p>
  </div>
);

export default FeaturedAppPreview;
